// src/store/slices/organization/thunks/organization/fetchOrgAdmins.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import type { AdminDTO } from '@/types/organization.dtos';
import type { AdminUser } from '@/types/organization.types';
import { mapAdminDTOsToAdmins } from '@/store/mappers/organization';

export const fetchOrgAdmins = createAdminAsyncThunk<
  AdminUser[],
  undefined,
  { rejectValue: string }
>(
  'organization/fetchAdmins',
  async(_, { extra: { organizationService }, rejectWithValue }) => {
    try {
      const dtos: AdminDTO[] = await organizationService.getAdmins();
      return mapAdminDTOsToAdmins(dtos);
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Failed to load administrators';
      return rejectWithValue(msg);
    }
  }
);
